import React, { useState, useMemo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Accordion from "./Accordion";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as LogoSVG } from "../../assets/images/logo.svg";
import { ReactComponent as AboutIcon } from "../../assets/images/companyIcons/about.svg";
import { ReactComponent as DetailsIcon } from "../../assets/images/companyIcons/details.svg";
import { ReactComponent as FinancialsIcon } from "../../assets/images/companyIcons/financials.svg";
import { ReactComponent as CompanyFinance } from "../../assets/images/companyIcons/CompanyFinance.svg";
import { ReactComponent as UploadIcon } from "../../assets/images/companyIcons/upload.svg";
import { clearUserInfo } from '../../store/auth/authSlice'
import {
  About,
  Industry,
  AddressContact,
  Social,
  LogoBanner,
} from "../../components/admin/Dashboard/mycompanies/CompleteCompanyProfile/About";
import {
  LicenseInformation,
  OwnershipStructure,
  AuthorizedSignatory,
  KeyPersonnel,
  RelatedEntities,
  BusinessRelation,
} from "../../components/admin/Dashboard/mycompanies/CompleteCompanyProfile/Details";
import {
  Insurance,
  BankingInformation,
  FinancialStatement,
} from "../../components/admin/Dashboard/mycompanies/CompleteCompanyProfile/Financial";
import CompanyProfileHeader from "../../components/admin/Dashboard/mycompanies/CompleteCompanyProfile/CompanyProfileHeader";
import Upload from "../../components/admin/Dashboard/mycompanies/CompleteCompanyProfile/UploadDocument/Upload";
import { ReactComponent as AboutImage } from "../../assets/images/companyIcons/upperAbout.svg";
import { ReactComponent as UploadImage } from "../../assets/images/companyIcons/UploadDocuments.svg";
import { ReactComponent as DetailsImage } from "../../assets/images/companyIcons/CompanyProfile/CompanyDetail.svg";
import {
  useGetCompanyQuery,
  useGetCompanyRequestStatusMutation, useGetCompanyDetailsMutation, useUpdateCompanyRequestStatusMutation
} from "../../store/Company/companyApiSlice";
import { setCurrentEditingCompany } from "../../store/Company/companySlice";
import { LoadingIcon, Modal, SessionExpired } from "../../components/common";
import { FinancialDocuments } from "../../components/admin/Dashboard/mycompanies/CompleteCompanyProfile/Financial/FinancialDocuments";
import { FinancialSetup } from "../../components/admin/Dashboard/mycompanies/CompleteCompanyProfile/Financial/FinancialSetup";
import { TaxCategoryDetails } from "../../components/admin/Dashboard/mycompanies/CompleteCompanyProfile/Details/TaxCategoryDetails";

const CompanyEditProfile = () => {
  const findProgressByKey = (key) => {
    const accordionsRawData = [
      {
        title: "About",
        progress: ["About Company", "Industry", "Address & Contact Information", "Social Media", "Logo & Banner"],
      },
      {
        title: "Details",
        progress: ["License Information", "Ownership Structure", "Authorized Signatory", "Key Personnel", "Related Entities", "Business Relation"],
      },
      {
        title: "Financial",
        progress: ["Banking Information", "Insurance", "Auditor Information", "Financial Documents"],
      },
      {
        title: "Upload Document",
        progress: ["MOA", "Trade License", "VAT Certificate"],
      },
    ];
    for (let i = 0; i < accordionsRawData.length; i++) {
      const accordion = accordionsRawData[i];
      const index = accordion.progress.indexOf(key);

      if (index !== -1) {
        return {
          title: accordion.title,
          key: key,
          index: index
        };
      }
    }

    // Return null if key is not found
    return null;
  }

  const getAccordianIndex = () => {
    const componentData = localStorage.getItem("CurrentComponent") ?? "About Company"
    return findProgressByKey(componentData);
  };
  const [getCompanyDetails] = useGetCompanyDetailsMutation();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [stepIndex, setStepIndex] = useState(getAccordianIndex()?.index ?? 0);
  const [currentComponent, setCurrentComponent] = useState(getAccordianIndex()?.key);
  const [currentAccordion, setCurrentAccordion] = useState(getAccordianIndex()?.title ?? "About");
  const [companyVerificationStatus, setcompanyVerificationStatus] =
    useState("pending");
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [getCompanyRequestStatus] = useGetCompanyRequestStatusMutation();
  const [requestID, setrequestID] = useState(null);
  const [updateCompanyRequestStatus] = useUpdateCompanyRequestStatusMutation();

  // const toggleAccordion = (accordionId) => {
  //   setActiveAccordion(activeAccordion === accordionId ? null : accordionId);
  //   handleCurrentAccordion(accordionId);
  //   fetchCompDetails();
  // };

  const toggleAccordion = (accordionId) => {
    setActiveAccordion((prev) => {
      // If clicking the same accordion, collapse it
      if (prev === accordionId) return null;

      // If switching to a new accordion
      const selectedAcc = accordions.find((a) => a.id === accordionId);
      if (selectedAcc) {
        // Set header and first component
        setCurrentUpperComponent(selectedAcc.upperComponent);
        setCurrentComponent(selectedAcc.progress[0].component);
        localStorage.setItem("CurrentComponent", selectedAcc.progress[0].label);
        localStorage.setItem("accordianIndex", 0);
      }

      return accordionId;
    });
  };


  const [currentUpperComponent, setCurrentUpperComponent] = useState(
    <CompanyProfileHeader
      Image={AboutImage}
      Heading="Complete Your Company Profile"
    />
  );
  const { userInfo, token, isLoggedIn } = useSelector((state) => state.auth);
  const { id } = useParams();
  const userCompanies = userInfo?.individual[0]?.individual || [];
  const companyInfo = userCompanies.find(company => company.companyID?.companyID === id);
  const role = companyInfo ? companyInfo.role : undefined;

  useEffect(() => {
    if (!role && !token) {
      navigate(`/search/${id}`)
    }
  }, [userInfo])
  const { data, isLoading, isError, error, refetch } = useGetCompanyQuery({
    companyId: id,
    token,
  });
  const [isSessionExpired, setSessionExpired] = useState(false);
  const sessionExpiredPopup = () => {
    setSessionExpired(!isSessionExpired);
    dispatch(clearUserInfo());
    navigate("/login");
  };
  useEffect(() => {
    if (isError) {
      if (error?.data?.code == 'token_not_valid') {
        setSessionExpired(true);
      }
    }

  }, [data, dispatch, isError,]);
  const companyStatus = async () => {
    let userindividualID = localStorage.getItem("userindividualID");
    let dataval = await getCompanyRequestStatus({
      companyID: id,
      individualID:
        userindividualID ||
        data?.userCompany[0]?.individualID?.individualID,
      token,
    });
    if (dataval) {
      let statusValue = dataval.data?.filter(
        (item) => item?.companyID?.companyID == id
      );
      if (statusValue?.length > 0) {
        let companyStatus = statusValue[statusValue.length - 1];
        setcompanyVerificationStatus(companyStatus);
        setrequestID(companyStatus?.requestID);
      }
    }
  };
  const companyStatusLatest = async () => {
    let response = "";
    let userindividualID = localStorage.getItem("userindividualID");
    let dataval = await getCompanyRequestStatus({
      companyID: id,
      individualID:
        userindividualID ||
        data?.userCompany[0]?.individualID?.individualID,
      token,
    });
    if (dataval) {
      let statusValue = dataval.data?.filter(
        (item) => item?.companyID?.companyID == id
      );
      if (statusValue?.length > 0) {
        let companyStatus = statusValue[statusValue.length - 1];
        response = companyStatus;
      }
    }
    return response;
  };
  useEffect(() => {
    let userindividualID = localStorage.getItem("userindividualID");

    if (userindividualID) {

      companyStatus();
    }
  }, [data,]);
  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/");
    }
  }, [isLoggedIn, data, navigate,]);

  const isCompanyVerified = data && data.status === "verified";
  const updateVerificationStatus = async (requestID) => {
    const updatecompanyStatus = await updateCompanyRequestStatus({
      requestID: requestID,
      token
    }).unwrap();
  }
  const handleUpdateStatus = async () => {
    let resp = await companyStatusLatest();
    if (resp?.status === 'Completed') {
      updateVerificationStatus(resp?.requestID)
    }
  }
  const handleNext = async (stepIndex, component, accordion) => {
    let resp = await companyStatusLatest();
    if (resp?.status === 'Completed') {
      updateVerificationStatus(resp?.requestID)
    }

    getCurrentComponent(component);
    setCurrentAccordion(accordion);
    localStorage.setItem("accordianIndex", stepIndex);
    toggleAccordion(accordion);
    setStepIndex(stepIndex);
    fetchCompDetails()
  };
  const handleSkip = (stepIndex, component, accordion) => {
    getCurrentComponent(component);
    setCurrentAccordion(accordion);
    localStorage.setItem("accordianIndex", stepIndex);
    toggleAccordion(accordion);
    setStepIndex(stepIndex);
    fetchCompDetails()

  };

  const handleBack = (stepIndex, component, accordion) => {
    getCurrentComponent(component);
    setCurrentAccordion(accordion);
    localStorage.setItem("accordianIndex", stepIndex);
    setStepIndex(stepIndex);
    fetchCompDetails()
  };

  useEffect(() => {
    if (data) {
      dispatch(setCurrentEditingCompany(data));
    }
  }, [data, dispatch,]);
  const fetchCompDetails = async () => {

    const tempdata = await getCompanyDetails({
      companyId: id,
      token,
    }).unwrap();
    if (tempdata)
      dispatch(setCurrentEditingCompany(tempdata));
  }

  const accordions = useMemo(() => {

    const accordions = [
      {
        title: "About",
        id: "About",
        content: "Content for About accordion goes here.",
        icon: <AboutIcon />,
        upperComponent: (
          <CompanyProfileHeader
            Image={AboutImage}
            Heading="Complete Your Company Profile"
          />
        ),
        progress: [
          {
            label: "About Company",
            isActive: true,
            component: <About onNext={handleNext} onSkip={handleSkip} verifyStatus={companyVerificationStatus?.status} />,
          },
          {
            label: "Industry",
            isActive: false,
            component: (
              <Industry
                verifyStatus={companyVerificationStatus?.status}
                onPrev={handleBack}
                onNext={handleNext}
                onSkip={handleSkip}
              />
            ),
          },
          {
            label: "Address & Contact Information",
            isActive: false,
            component: (
              <AddressContact
                verifyStatus={companyVerificationStatus?.status}
                onPrev={handleBack}
                onNext={handleNext}
                handleUpdateStatus={handleUpdateStatus}

                onSkip={handleSkip}
              />
            ),
          },
          {
            label: "Social Media",
            isActive: false,
            component: (
              <Social
                verifyStatus={companyVerificationStatus?.status}
                onPrev={handleBack}
                onNext={handleNext}
                onSkip={handleSkip}
              />
            ),
          },
          {
            label: "Logo & Banner",
            isActive: false,
            component: (
              <LogoBanner
                verifyStatus={companyVerificationStatus?.status}
                onPrev={handleBack}
                onNext={handleNext}
                onSkip={handleSkip}
              />
            ),
          },
        ],
      },
      {
        title: "Details",
        id: "Details",
        content: "Content for Details accordion goes here.",
        icon: <DetailsIcon />,
        upperComponent: (
          <CompanyProfileHeader
            Image={DetailsImage}
            Heading="Provide Company Details"
          />
        ),
        progress: [
          {
            label: "License Information",
            isActive: true,
            component: (
              <LicenseInformation
                onPrev={handleBack}
                onNext={handleNext}
                onSkip={handleSkip}
                verifyStatus={companyVerificationStatus?.status}
                handleUpdateStatus={handleUpdateStatus}

              />
            ),
          },
          {
            label: "Tax Information",
            isActive: false,
            component: (
              <TaxCategoryDetails
                onPrev={handleBack}
                onNext={handleNext}
                verifyStatus={companyVerificationStatus?.status}
                handleUpdateStatus={handleUpdateStatus}
                compRefetch={refetch}
                onSkip={handleSkip}
              />
            ),
          },
          {
            label: "Ownership Structure",
            isActive: false,
            component: (
              <OwnershipStructure
                onPrev={handleBack}
                onNext={handleNext}
                verifyStatus={companyVerificationStatus?.status}
                handleUpdateStatus={handleUpdateStatus}
                onSkip={handleSkip}
                compRefetch={refetch}
              />
            ),
          },
          {
            label: "Authorized Signatory",
            isActive: false,
            component: (
              <AuthorizedSignatory
                onPrev={handleBack}
                onNext={handleNext}
                verifyStatus={companyVerificationStatus?.status}
                handleUpdateStatus={handleUpdateStatus}
                compRefetch={refetch}
                onSkip={handleSkip}
              />
            ),
          },
          {
            label: "Key Personnel",
            isActive: false,
            component: (
              <KeyPersonnel
                onPrev={handleBack}
                onNext={handleNext}
                verifyStatus={companyVerificationStatus?.status}
                handleUpdateStatus={handleUpdateStatus}
                compRefetch={refetch}
                onSkip={handleSkip}
              />
            ),
          },
          {
            label: "Related Entities",
            isActive: false,
            component: (
              <RelatedEntities
                onPrev={handleBack}
                onNext={handleNext}
                verifyStatus={companyVerificationStatus?.status}
                handleUpdateStatus={handleUpdateStatus}
                compRefetch={refetch}
                onSkip={handleSkip}
              />
            ),
          },
          {
            label: "Business Relation",
            isActive: false,
            component: (
              <BusinessRelation
                onPrev={handleBack}
                onNext={handleNext}
                verifyStatus={companyVerificationStatus?.status}
                handleUpdateStatus={handleUpdateStatus}
                compRefetch={refetch}
                onSkip={handleSkip}
              />
            ),
          },
        ],
      },
      {
        title: "Financial",
        content: "Content for Details accordion goes here.",
        id: "Financial",
        icon: <FinancialsIcon />,
        upperComponent: (
          <CompanyProfileHeader
            Image={CompanyFinance}
            Heading="Company Financials Details"
          />
        ),
        progress: [
          {
            label: "Banking Information",
            isActive: true,
            component: (
              <BankingInformation
                onPrev={handleBack}
                handleUpdateStatus={handleUpdateStatus}
                onNext={handleNext}
                compRefetch={refetch}
                onSkip={handleSkip}
              />
            ),
          },
          {
            label: "Insurance",
            isActive: true,
            component: (
              <Insurance
                onPrev={handleBack}
                onNext={handleNext}
                verifyStatus={companyVerificationStatus?.status}
                onSkip={handleSkip}
                compRefetch={refetch}
                handleUpdateStatus={handleUpdateStatus}
              />
            ),
          },
          {
            label: "Auditor Information",
            isActive: false,
            component: (
              <FinancialStatement
                onPrev={handleBack}
                verifyStatus={companyVerificationStatus?.status}
                onNext={handleNext}
                onSkip={handleSkip}
              />
            ),
          },
          {
            label: "Financial Documents",
            isActive: false,
            // component: (
            // <FinancialDocuments
            //   onPrev={handleBack}
            //   verifyStatus={companyVerificationStatus?.status}
            //   onNext={handleNext}
            //   onSkip={handleSkip}
            // />
            // ),
            component: (
              <FinancialSetup
                onPrev={handleBack}
                verifyStatus={companyVerificationStatus?.status}
                onNext={handleNext}
                onSkip={handleSkip}
              />
            ),
          },
        ],
      },
      {
        title: "Upload Document",
        id: "Upload Document",
        content: "Content for Details accordion goes here.",
        icon: <UploadIcon />,
        upperComponent: (
          <CompanyProfileHeader Image={UploadImage} Heading="Documents" />
        ),

        progress: [
          {
            label: "MOA",
            isActive: true,
            component: <Upload heading={"Upload MOA"} />,
          },
          {
            label: "Trade License",
            isActive: true,
            component: <Upload heading={"Upload Trade License"} />,
          },
          {
            label: "VAT Certificate",
            isActive: false,
            component: <Upload heading={"VAT Certificate"} />,
          },
        ],
      },
    ];
    return accordions;
  }, []);

  useEffect(() => {
    companyStatusLatest();

    getCurrentComponent(localStorage.getItem("CurrentComponent") || "About Company");
  }, []);

  const componentsArray = useMemo(() => {
    let componentsArray = accordions
      .map((accordion) => accordion.progress)
      .flat();

    return componentsArray;
  }, [accordions]);

  function getCurrentComponent(component) {
    localStorage.setItem("CurrentComponent", component);
    if (component !== 'Financial Documents')
      localStorage.removeItem('selectedObject');
    if (component == null || component == "null") {
      component = "About Company";
    }
    let currentComponent = null;
    for (let i = 0; i < componentsArray.length; i++) {
      if (componentsArray[i].label === component) {
        currentComponent = componentsArray[i].component;
        localStorage.setItem("accordianIndex", i);
      }
    }
    setCurrentComponent(currentComponent);
  }

  function handleCurrentAccordion(title, stepIndex) {
    let [currentComponent] = accordions.filter((acc) => acc.title === title);
    //setCurrentUpperComponent(currentComponent.upperComponent);
    if (stepIndex === 0) {
      setCurrentComponent(currentComponent.progress[0].component);
      localStorage.setItem("accordianIndex", stepIndex);
    }
  }

  if (isLoading)
    return (
      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <LoadingIcon />
        </div>
      </div>
    );

  return (
    <>
      <div className=" h-screen overflow-hidden bg-white max-w-[1920px] mx-auto">
        <div className="flex flex-col sm:flex-row h-screen overflow-hidden max-w-[1920px] mx-auto ">
          <div className="sm:min-h-screen flex flex-col items-center sm:w-64 w-full sm:min-w-[25%] px-4 sm:pl-14">
            <Link to="/" className="max-w-screen-2xl mx-auto py-8 px-4 ">
              <LogoSVG />
            </Link>
            {isSessionExpired && <Modal modalHandle={sessionExpiredPopup}>
              <SessionExpired handleNavigate={sessionExpiredPopup} />
            </Modal>}
            <div className="w-full max-w-9xl mx-auto py-4 px-4 overflow-auto mt-5 sm:mt-20 according">
              {accordions.map((accordion, index) => (
                <Accordion
                  key={index}
                  title={accordion.title}
                  links={accordion.progress}
                  icon={accordion.icon}
                  getCurrentComponent={getCurrentComponent}
                  stepIndex={stepIndex}
                  currentAccordion={currentAccordion}
                  isActive={activeAccordion === accordion.id}
                  onClick={() => toggleAccordion(accordion.id)}
                  onActivateFirstStep={(index) => setStepIndex(index)} // ✅ new handler
                />
              ))}
            </div>
          </div>
          <div className="w-full max-w-9xl mx-auto py-4 px-4 overflow-auto">
            {currentUpperComponent}
            {currentComponent}
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyEditProfile;
